const Data = {
    document  : (document, mask)=> {return({
      id: "",
      type: "text",
      name: "documento",
      placeholder:
        document == "cpf" ? "000.000.000-00" : "00.000.000/0000-00",
      label: document == "cpf" ? "CPF" : "CNPJ",
      mask: document == "cpf" ? mask.cpfMask : mask.cnpjMask,
      value: "",
      info: {
        description:  document == "cpf" ? "cpf":"cnpj",
      },
    })  
 }};
 
 export default Data;
 